<template>
  <div class="row">
    <div class="col-xl-8 order-xl-1">
      <div class="card">
        <div class="card-header">
          <div class="row align-items-center">
            <div class="col-8"></div>
          </div>
        </div>
        <div class="card-body">
          <form>
            <h6 class="heading-small text-muted mb-4">Page information</h6>
            <div class="pl-lg-4">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label class="form-control-label" for="input-username"
                      >Name</label
                    >
                    <input
                      type="text"
                      id="input-username"
                      class="form-control"
                      placeholder="Username"
                      value="lucky.jesse"
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label class="form-control-label" for="input-email"
                      >Eddress</label
                    >
                    <input
                      type="email"
                      id="input-email"
                      class="form-control"
                      placeholder="jesse@example.com"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label class="form-control-label" for="input-first-name"
                      >Descriptiuon</label
                    >
                    <textarea
                      rows="4"
                      class="form-control"
                      placeholder="Never give up! :)"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
  <!-- </div> -->
</template>

<script>
export default {
  name: 'PageProfile'
}
</script>
